/* eslint-disable react/prop-types */
import React from 'react'
import Modal from 'react-modal'
import { useTranslation } from 'react-i18next'
import PlayerProgress from '../reports/PlayerProgress'

const PlayerProgressModal = props => {
  const { t } = useTranslation()
  return (
    <Modal
      isOpen={props.showPlayerProgressModal}
      onRequestClose={props.closePlayerProgressModal}
      contentLabel={t('profile.playerProgress.contentLabel')}
    >
      <div className='modal-content animated fadeIn'>
        <div>
          <button
            onClick={props.closePlayerProgressModal}
            className='confirmation-modal-close-btn btn-link'
          >
            <i className='fa fa-times confirmation-modal-close-icon' />
          </button>
          <h1>{t('profile.common.juniorDevelopmentModel')}</h1>
          <div
            className='container mt-5'
            style={{ border: '1px solid #ccc', borderRadius: '10px' }}
          >
            <PlayerProgress
              user={props.user}
              title={props.title}
              studentSelected={props.studentSelected}
              division={props.division}
              fromProfile={props.fromProfile}
              handlePlayTypeChange={props.handlePlayTypeChange}
              playType={props.playType}
              loader={props.loader}
              handleGoalChange={props.handleGoalChange}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PlayerProgressModal
